export default "__VITE_ASSET__ab5bb8ad__"